export const environment = {
  firebase: {
    locationId: 'asia-south1',
    apiKey: "AIzaSyBUGsA07wQlPKNPAEk6dAHgmN2X-VkSw6I",
    authDomain: "allyot-ea84d.firebaseapp.com",
    projectId: "allyot-ea84d",
    storageBucket: "allyot-ea84d.appspot.com",
    messagingSenderId: "618275083016",
    appId: "1:618275083016:web:f4bcdeeba4cb581fba92bd",
    measurementId: "G-EDCYF8D58W"
  },
  production: false,
  // baseUrl: 'http://localhost:8100',
  baseUrl: 'https://vanshavali.web.app',
  envName: 'PROD',
  apkUrl: 'https://play.google.com/store/apps/details?id=com.vanshavali.app',
  supabaseUrl: 'https://ydweqgscbnzyggfjebrv.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlkd2VxZ3NjYm56eWdnZmplYnJ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY2MDI0NTksImV4cCI6MjA1MjE3ODQ1OX0.3UlVUqojqZTolRtCZsuPryWnpes3ThuDwwNeHo5mnXE',
  // ping db.ydweqgscbnzyggfjebrv.supabase.co
  // apiUrl: 'http://localhost:3000'  //local dev api,
  apiUrl: 'https://tsa-2p9t.onrender.com'  //prod api,
  // apiUrl: "https://tsa-41wy.onrender.com" // dev api
};
// pg_dump --dbname='postgresql://postgres:BHU%2Anji9VGY%26@db.ydweqgscbnzyggfjebrv.supabase.co:5432/postgres' --file=vanshavali-qa-2025-10-05.sql
// pg_dump --schema-only --no-owner --no-privileges --host=db.ydweqgscbnzyggfjebrv.supabase.co --port=5432 --username=postgres --dbname=postgres > qa_structure.sql
// BHU*nji9VGY&
